import Marquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "@/data/content";

export const MarqueeStrip = () => {
  return (
    <section
      data-testid="marquee-section"
      className="border-y border-epic-line bg-epic-bg py-6 md:py-8"
    >
      <Marquee speed={38} gradient={false} autoFill>
        {MARQUEE_ITEMS.map((item, i) => (
          <span key={i} className="marquee-item mx-10 md:mx-16">
            <span className="font-editorial italic text-2xl md:text-4xl text-epic-text">
              {item}
            </span>
            <span className="ml-10 md:ml-16 text-epic-accent text-lg">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
};
